import {MoonIcon, SunIcon} from '@heroicons/react/outline';

const DarkModeToggle = ({
  isDark,
  toggleDarkMode,
}: {
  isDark: boolean;
  toggleDarkMode: () => void;
}) => (
  <div>
    <label className="inline-flex items-center cursor-pointer">
      <span className="me-3 text-sm font-medium text-gray-900 dark:text-gray-300 w-5 h-5 flex items-center justify-center">
        <SunIcon className={'w-5 h-5 text-yellow-500'} />
      </span>

      <input
        type="checkbox"
        className="sr-only peer"
        onChange={toggleDarkMode}
        checked={isDark}
      />
      <div
        className="relative w-9 h-5 bg-gray-200 rounded-full peer dark:bg-gray-700 
          peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 
          dark:peer-focus:ring-blue-800
          peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600
          after:content-[''] after:absolute after:top-[2px] after:start-[2px] 
          after:w-4 after:h-4 after:bg-white after:border after:border-gray-300 
          dark:after:border-gray-600 after:rounded-full after:transition-all 
          peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full 
          peer-checked:after:border-white"
      ></div>

      <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 w-5 h-5 flex items-center justify-center">
        <MoonIcon className={'w-5 h-5 text-cyan-700'} />
      </span>
    </label>
  </div>
);

export default DarkModeToggle;
